var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesBranco09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.12,24.06c3.86,0,7.01-3.13,7.01-6.98v-1.83c0-3.85-3.14-6.98-7.01-6.98s-7.01,3.13-7.01,6.98v1.83 C40.11,20.93,43.25,24.06,47.12,24.06z M43.08,15.26c0-2.21,1.81-4,4.03-4c2.22,0,4.04,1.8,4.04,4v1.83c0,2.21-1.81,4-4.04,4 c-2.22,0-4.03-1.8-4.03-4V15.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.12,34.33c-0.85,0-1.6,0.34-2.23,0.82c-0.63-0.48-1.38-0.82-2.23-0.82c-2.05,0-3.72,1.66-3.72,3.7h2.97 c0-0.8,1.49-0.8,1.49,0c0,2.04,1.67,3.7,3.72,3.7v-2.97c-0.4,0-0.74-0.33-0.74-0.73c0-0.8,1.49-0.8,1.49,0h2.97 C55.84,35.99,54.17,34.33,52.12,34.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.12,25.27c-4.26,0-8.03,2.13-10.31,5.37c0.7,0.82,1.33,1.69,1.9,2.61c1.64-2.96,4.77-5,8.41-5 c5.31,0,9.63,4.29,9.63,9.56v8.94h2.97v-8.94C59.72,30.89,54.06,25.27,47.12,25.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.73,25.7c-10.72,0-19.44,8.67-19.44,19.34v14.57h2.97V45.04c0-9.02,7.39-16.37,16.47-16.37 s16.47,7.34,16.47,16.37v14.44h2.97V45.04C39.17,34.38,30.45,25.7,19.73,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.73,24.05c5.74,0,10.41-4.65,10.41-10.36v-2.96c0-5.71-4.67-10.36-10.41-10.36S9.32,5.03,9.32,10.74v2.96 C9.32,19.41,13.99,24.05,19.73,24.05z M12.29,10.74c0-4.07,3.33-7.38,7.43-7.38s7.43,3.31,7.43,7.38v2.96 c0,4.07-3.33,7.38-7.43,7.38s-7.43-3.31-7.43-7.38V10.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.88,42.85c-1.42,0-2.71,0.58-3.63,1.51c-0.93-0.93-2.21-1.51-3.63-1.51c-2.82,0-5.12,2.29-5.12,5.1h2.97 c0-1.17,0.96-2.13,2.15-2.13s2.15,0.95,2.15,2.13c0,2.81,2.3,5.1,5.12,5.1v-2.97c-1.18,0-2.15-0.96-2.15-2.13s0.96-2.13,2.15-2.13 c1.18,0,2.15,0.95,2.15,2.13H33C33,45.14,30.71,42.85,27.88,42.85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesBranco09);
export default __webpack_public_path__ + "static/media/Icones_Branco-09.3bed87738468de79448e1f12164d98b6.svg";
export { ForwardRef as ReactComponent };